import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { toast } from "@/hooks/useToast"
import { AppointmentDrawerContent } from "@/modules/waiting-room/components/appointment-drawer"
import { useWaitingRoomDrawerQuery } from "@/modules/waiting-room/services/useWaitingRoomDrawerQuery"

type AppointmentDrawerCheckerProps = {
  selectedId: string
  onOpenDrawer?: (close?: boolean) => void
  onClose?: () => void
  isPreview: boolean
}

const AppointmentDrawerChecker = ({ selectedId, isPreview, onClose, onOpenDrawer }: AppointmentDrawerCheckerProps) => {
  const waitingRoomAppointment = useWaitingRoomDrawerQuery(selectedId)
  const { t } = useTranslation()

  useEffect(() => {
    if (!waitingRoomAppointment) {
      toast({ description: t("scheduling.waitingRoom.appointmentUnavailable") })
      onClose?.()
    } else {
      onOpenDrawer?.()
    }
  }, [waitingRoomAppointment, t, onClose, onOpenDrawer])

  if (!waitingRoomAppointment) {
    return null
  }

  return (
    <AppointmentDrawerContent
      key={selectedId}
      onClose={onClose}
      waitingRoomAppointmentReference={waitingRoomAppointment}
      isPreview={isPreview}
    />
  )
}

export { AppointmentDrawerChecker }
